import React from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'

import CardTooltip from 'components/common/CardTooltip'
import Popover from 'components/common/Popover'
import Text from 'components/common/Text'
import Icon from 'components/Icon'
import theme from 'theme'

const PreviewApiKeyPopover: React.FC<{
  apiKey: string
  className?: string
}> = ({ apiKey, className = '' }) => {
  const [isCopied, setIsCopied] = React.useState(false)
  return (
    <Popover
      alignPopover={Popover.ALIGN_CENTER}
      onClose={() => setIsCopied(false)}
    >
      {({ getTargetProps, getPopoverProps }) => (
        <>
          <div
            {...getTargetProps({
              className: className,
              css: {
                display: 'flex',
                alignItems: 'center',
                color: 'inherit',
                fontSize: theme.fontSizes[2],
                '&:hover': {
                  cursor: 'pointer'
                }
              }
            })}
          >
            <Icon icon="copy" />
          </div>
          <CardTooltip
            displayArrow
            size="small"
            variation={isCopied ? 'primary' : 'dark'}
            {...getPopoverProps({
              css: {
                display: 'flex',
                alignItems: 'center',
                minWidth: 180,
                maxWidth: 'auto',

                '&:hover': {
                  cursor: 'pointer'
                }
              }
            })}
          >
            <CopyToClipboard text={apiKey} onCopy={() => setIsCopied(true)}>
              <div
                css={{
                  color: 'white'
                }}
              >
                <Text as="small" css={{ color: 'inherit' }} weight="normal">
                  {isCopied ? 'Successfully Copied' : 'Click to copy API Key'}
                </Text>
                <Text as="small" css={{ color: 'inherit' }}>
                  {apiKey.slice(0, 16)}…{apiKey.slice(-16)}
                </Text>
              </div>
            </CopyToClipboard>
          </CardTooltip>
        </>
      )}
    </Popover>
  )
}

export default PreviewApiKeyPopover
